<div class="flex flex-col lg:flex-row gap-4">
  <!-- Left Content -->
  <div class="flex h-fit flex-col w-full lg:w-[50%] p-6 lg:p-11 card">
    <form class="flex flex-col h-full">
      <div class="flex flex-col gap-3 lg:gap-1.5 w-full flex-grow">
        <p class="text-2xl lg:text-4xl font-bold mb-4">View Problem</p>

        <!-- Problem Name -->
        <div class="flex-col w-full">
          <div class="flex">
            <legend class="fieldset-legend">Problem Name</legend>
          </div>
          <input
            name="problemName"
            type="text"
            [value]="problemData()?.problemTitle"
            class="w-full input placeholder-gray-300 rounded-lg"
            placeholder="Enter Problem Name"
            (keydown.enter)="$event.preventDefault()"
            disabled />
        </div>

        <!-- Problem Difficulty / Duration -->
        <div class="flex flex-col sm:flex-row gap-4">
          <!-- Problem Difficulty -->
          <div class="flex-col w-full sm:w-[65%]">
            <div class="flex">
              <legend class="fieldset-legend">Difficulty of Problem</legend>
            </div>
            <app-select
            data-testid="difficulty-selector"
              [id]="'difficulty-selector'"
              [name]="'difficulty-selector'"
              [items]="selectDifficultyItems()"
              [(selectedItem)]="selectedDifficulty"
              [disabled]="true" />
          </div>

          <!-- Problem Duration -->
          <div class="flex-col w-full sm:w-[35%]">
            <div class="flex">
              <legend class="fieldset-legend">Duration</legend>
            </div>
            <label class="input rounded-lg w-full">
              <input
                name="problemDuration"
                type="number"
                [value]="problemData()?.duration"
                min="1"
                (keydown.enter)="$event.preventDefault()"
                disabled
                id="problem-duration"/>
              <span class="label">minutes</span>
            </label>
          </div>
        </div>

        <!-- Problem Description -->
        <div class="flex-col w-full">
          <div class="flex">
            <legend class="fieldset-legend">Description</legend>
          </div>
          <div class="w-full" data-testid="description-editor">
            <div #quillEditorContainer></div>
          </div>
        </div>
      </div>

      <!-- Button Container -->
      <div class="flex flex-col mt-5 gap-2">
        <div class="flex w-full flex-row gap-3">
          <div class="w-full">
            <app-button
              type="button"
              label="Back"
              (clicked)="goToProblems()" />
          </div>
        </div>
        <div class="w-full">
          <p class="text-center text-gray-500">
            Make sure all test cases are configured, description is provided, and verification is completed before creating the problem.
          </p>
        </div>
      </div>
    </form>
  </div>

  <!-- Right Content -->
  <div class="flex flex-col lg:w-[50%] w-full h-full gap-4">
    <!-- Tab Selector with Side Animation -->
    <div class="flex flex-row justify-center items-center card overflow-hidden h-15 relative p-2">
      <div class="flex justify-center w-full h-full relative">
        <!-- Sliding Background -->
        <div
          class="absolute bg-primary h-full w-1/3 rounded-lg transition-all duration-300"
          [style.left]="selectedTab() === 'initial-code' ? '0%' : selectedTab() === 'test-case' ? '33.33%' : '66.66%'">
        </div>
        <!-- Buttons -->
        <button
          id="initial-code-button"
          (click)="handleSelectTab('initial-code')"
          class="w-1/3 text-base xl:text-xl font-semibold m-2 cursor-pointer relative z-1 transition-colors duration-300"
          [class.text-white]="selectedTab() === 'initial-code'">
          Initial code
        </button>
        <button
          id="test-case-button"
          (click)="handleSelectTab('test-case')"
          class="w-1/3 text-base xl:text-xl font-semibold m-2 cursor-pointer relative z-1 transition-colors duration-300"
          [class.text-white]="selectedTab() === 'test-case'">
          Test Case
        </button>
        <button
          id="verification-code-button"
          (click)="handleSelectTab('verification-code')"
          class="w-1/3 text-base xl:text-xl font-semibold m-2 cursor-pointer relative z-1 transition-colors duration-300"
          [class.text-white]="selectedTab() === 'verification-code'">
          Verification code
        </button>
      </div>
    </div>

    <!-- Content Area -->
    <div class="flex-1 card overflow-hidden">
      @if (selectedTab() === 'initial-code' || selectedTab() === 'verification-code') {
        <div
          class="h-[50vh] lg:h-[60vh] bg-white shadow-lg overflow-hidden flex flex-col flex-shrink-0"
          [class.rounded-lg]="selectedTab() === 'initial-code'">
          <div class="w-full flex flex-col sm:flex-row items-start sm:items-center px-7 py-6 flex-shrink-0 gap-2 sm:gap-0">
            <p class="w-full font-semibold text-lg sm:text-xl lg:text-2xl">
              Write your code here..
            </p>
            <div class="flex w-full sm:justify-end">
              <app-select
                [id]="'language-selector'"
                [name]="'language-selector'"
                [items]="selectLanguageItems()"
                [(selectedItem)]="selectedLanguage" />
            </div>
          </div>
          <div class="flex-1 min-h-0" id="code-editor-container-{{selectedTab()}}">
            <div #codeEditorOutlet></div>
          </div>
        </div>
      } @else {
        <div class="w-full p-2 sm:p-4 gap-2.5 flex flex-col"  data-testid="test-case-container">
        @for (testCase of testCases(); track testCase.id; let i = $index) {
          <app-test-case-item
            [index]="i + 1"
            [data]="testCase"
            [disabled]="true" />
          }
          <div class="text-sm text-gray-500">
            * Provide function parameters separated by commas: param1,
            param2, ... <br />
            * For array parameters, use square brackets: [1,2] <br />
            * Example: [1,2], "abc", true, [3,4,5]
          </div>
        </div>
      }
    </div>
  </div>
</div>

